{
  "layouts.page.title": "AGOBIS",
  "layouts.page.titleNavigation": "AGOBIS Navigation",
  "Fremdsystem": "ERS"
}
